import _objectSpread from "D:/WebBuild/teamCity/buildAgent/work/f0b2174a44415a20/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { request } from '@/api/index';
var isPro = process.env.VUE_APP_BUILD_TYPE === 'pro';
import { api2 } from "@api/env";
import qs from 'qs';
var uri2 = isPro ? api2 : '';
var baseURL = api2;
var options = {
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  },
  transformRequest: [function (data) {
    // 在请求之前对data传参进行格式转换
    return qs.stringify(data);
  }]
};
export function getDetail(data) {
  return request(_objectSpread({
    url: '/Extenstion/TenantDetails',
    method: 'post',
    data: data
  }, options));
}
export function tenantDetailSubmit(data) {
  return request(_objectSpread({
    url: '/Extenstion/TenantModify',
    method: 'post',
    data: data
  }, options));
}
export function fileUpload(data) {
  return request({
    url: '/File/UploadFile',
    method: 'post',
    data: data,
    baseURL: baseURL,
    timeout: 6000 * 5,
    transformRequest: [function (d) {
      return d;
    }]
  });
}
export function uploadTemplate(data) {
  return request({
    url: '/api/Common/ImportTenantSetting',
    method: 'post',
    data: data,
    timeout: 6000 * 5,
    transformRequest: [function (d) {
      return d;
    }]
  });
}
var downLoadTemplate = '/api/Common/DownLoadTenantSettingTmp';
export { downLoadTemplate };